import { Text } from "rebass/styled-components";
import styled from "styled-components";

import { ReasonIcon } from "../ReasonIcon";
import { SUGGESTED_REASON_CONFIG } from "../../Views/Homepage/SuggestedItem/reasonConfig";

interface ISuggestionBadgeProps {
  reason: string;
  showTooltip?: boolean;
}

export const SuggestionBadge = ({
  reason,
  showTooltip = false,
}: ISuggestionBadgeProps) => {
  const reasonConfig = SUGGESTED_REASON_CONFIG[reason];

  if (!reasonConfig) return null;

  return (
    <ReasonBadge>
      <ReasonIcon reason={reason} showTooltip={showTooltip} />
      {reasonConfig.display}
    </ReasonBadge>
  );
};

const ReasonBadge = styled(Text)`
  align-items: center;
  backdrop-filter: blur(8px);
  background: ${({ theme }) => theme.colors.midnightAlpha50};
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  color: ${({ theme }) => theme.colors.ice};
  display: inline-flex;
  font-size: 10.5px;
  font-weight: 600;
  justify-content: center;
  letter-spacing: 0.01em;
  line-height: 1;
  padding: 3px 9px 3px 4px;
`;
